var transformDepartmentItemColumn = function transformDepartmentItemColumn(_ref) {
  var column_sections = _ref.column_sections;
  return column_sections.map(function (colSect) {
    return {
      title: colSect.title,
      url: colSect.url,
      titleType: colSect.title_type,
      seo: colSect.seo,
      items: colSect.links.map(function (link) {
        return {
          title: link.title,
          url: link.url,
          seo: link.seo
        };
      })
    };
  });
};
var getLinksFromColumns = function getLinksFromColumns(columns) {
  var links = [];
  columns.forEach(function (column) {
    return column.forEach(function (columnItem) {
      if (columnItem.url && columnItem.titleType !== 'no_link') {
        links.push({
          title: columnItem.title,
          url: columnItem.url,
          seo: columnItem.seo
        });
      }
      columnItem.items.forEach(function (subItem) {
        return links.push(subItem);
      });
    });
  });
  return links;
};
var getSeoLinksFromColumns = function getSeoLinksFromColumns(columns) {
  return getLinksFromColumns(columns).filter(function (link) {
    return link.seo !== 'exclude';
  }).map(function (link) {
    return {
      title: link.title,
      url: link.url
    };
  });
};
var transformDepartmentItem = function transformDepartmentItem(_ref2) {
  var category = _ref2.category;
  var columns = category.columns.map(transformDepartmentItemColumn);
  return {
    title: category.title,
    url: category.url,
    seo: category.seo,
    columns,
    seoLinks: getSeoLinksFromColumns(columns),
    color: category.department_color.title_color
  };
};
export var legacyTransformToDepartmentsProp = function legacyTransformToDepartmentsProp(_ref3) {
  var departments = _ref3.navigation_categories;
  return departments.map(transformDepartmentItem);
};